import React from "react";

const inputCls = "w-full py-2.5 px-3 rounded-xl bg-[#020617] border border-slate-700 text-sm text-white";

export default function StopFields({ prefix, title, value, onChange, required = false }) {
    const set = (k) => (e) => onChange({ ...value, [`${prefix}_${k}`]: e.target.value });
    const v = (k) => value[`${prefix}_${k}`] || "";
    return (
        <div className="rounded-xl border border-slate-700 p-4 space-y-3" data-testid={`${prefix}-fields`}>
            <div className="text-xs font-semibold uppercase tracking-widest text-orange-300">{title}</div>
            <div>
                <label className="text-xs text-slate-400 mb-1.5 block">Adresse{required && " *"}</label>
                <textarea rows={2} required={required} value={v("address")} onChange={set("address")} data-testid={`${prefix}-address`} placeholder="N°, rue, code postal" className={inputCls} />
            </div>
            <div className="grid grid-cols-2 gap-3">
                <div>
                    <label className="text-xs text-slate-400 mb-1.5 block">Ville{required && " *"}</label>
                    <input required={required} value={v("city")} onChange={set("city")} data-testid={`${prefix}-city`} className={inputCls} />
                </div>
                <div>
                    <label className="text-xs text-slate-400 mb-1.5 block">Pays</label>
                    <input value={v("country")} onChange={set("country")} data-testid={`${prefix}-country`} className={inputCls} />
                </div>
                <div>
                    <label className="text-xs text-slate-400 mb-1.5 block">Nom du contact{required && " *"}</label>
                    <input required={required} value={v("contact_name")} onChange={set("contact_name")} data-testid={`${prefix}-contact-name`} className={inputCls} />
                </div>
                <div>
                    <label className="text-xs text-slate-400 mb-1.5 block">Téléphone du contact</label>
                    <input value={v("contact_phone")} onChange={set("contact_phone")} data-testid={`${prefix}-contact-phone`} className={inputCls} />
                </div>
            </div>
        </div>
    );
}
